<template>
	<div :class="className" :style="{height:height,width:width}"></div>
</template>

<script>
	import echarts from 'echarts';
	require('echarts/theme/macarons'); // echarts 主题
	// import {
	// 	getReportStatisticsCount
	// } from "api/edu/administrators/index";
	export default {
		props: {
			className: {
				type: String,
				default: 'chart'
			},
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: '100%'
			},
			totalNum: 0,
			stateRegisterNum: 0
		},
		data() {
			return {
				chart: null
			};
		},
		// mounted() {
		// 	//this.initChart();
		// 	this.getList();
		// },
		beforeDestroy() {
			if (!this.chart) {
				return
			}
			this.chart.dispose();
			this.chart = null;
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
			}
		},
		created() { //创建完成（可以访问当前this实例）
			
		},
		mounted() {
			let _this = this; // 声明一个变量指向Vue实例this，保证作用域一致
			this.timer = setInterval(() => {
				// _this.getList();
				//console.log(_this.date);
			}, 150000);
            this.getList();
		},
		methods: {
			getList() {
				let that = this;
				// getReportStatisticsCount().then(res => {
				// 	if (res.success) {
				// 		that.stateRegisterNum = res.result.stateRegisterNum;
				// 		that.totalNum = res.result.totalNum;
				// 		that.initChart();
				// 	}
				// })
			},
			initChart() {
				this.chart = echarts.init(this.$el, 'macarons');

				this.chart.setOption({
					title: {
						text: '已预约人数',
						x: 'left',
						//backgroundColor: '#fff',
						 textStyle: {//主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
						                fontFamily: 'Arial, Verdana, sans...',
						                fontSize: 14,
						                fontStyle: 'normal',
						                fontWeight: 'normal',
										color:'#333'
						            },
					},
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b} : {c} ({d}%)'
					},
					legend: {
						x: 'center',
						y: 'bottom',
						data: ['学生', '老师'],
						textStyle: { //图例文字的样式
							color: '#333',
							fontSize: 12
						}
					},
					calculable: true,
					series: [{
						name: '',
						type: 'pie',
						//roseType: 'radius',
						data: [{
								value: this.stateRegisterNum,
								name: '学生',
								color: '#fff'
							},
							{
								value: this.totalNum - this.stateRegisterNum,
								name: '老师'
							},

						],
						animationEasing: 'cubicInOut',
						animationDuration: 2600,
						label: {
							normal: {
								show: true,
								position: 'inner',
								textStyle: {
									fontWeight: 200,
									fontSize: 20 //文字的字体大小
								},
								formatter: '{d}%',
								/*饼状图内显示百分比*/
								// data:['40%','60%'],
							},

							emphasis: {
								show: false,
								/*空心文字出现*/
							}
						},
					}],
					color: ['#FFB981','#2EC7C9'],
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/editor/pieChart1.vue